import { usePathname } from 'next/navigation';



import { DebugOnlyWrapper } from 'components/common/debug-only-wrapper';
import HubsConnectionGuard from 'components/complex/hubs-connection-guard/hubs-connection-guard';
import { Skeleton } from 'components/ui/skeleton';



import { useActiveFaults } from 'hooks/statekeeping';
import { useNewNotificationIndicator } from 'hooks/useNewNotificationIndicator';



import { useRobotId } from 'lib/api/myRobot';
import { Permission } from 'lib/constants/role-types';
import { useIsWearable } from 'hooks/statekeeping';



import { HUB_URL } from '../../../../hooks/signalR';
import { SidebarLink } from '../sidebar-link';
import DebugMenu from './debug-menu';
import SidebarRobotInfo from './sidebar-robot-info';
import { WebhookIcon } from 'lucide-react';


const SidebarRobot = () => {
  const { newNotificationIndicator } = useNewNotificationIndicator();

  const { robotId } = useRobotId();
  const { activeFaults } = useActiveFaults();
  const activeFaultsIndicator = activeFaults?.length > 0;
  const isWearable = useIsWearable();

  const pathname = usePathname();

  const isSettingsPage = pathname?.includes('/settings');

  return (
    <>
      <div>
        <HubsConnectionGuard
          requiredConnections={[HUB_URL.TWIN]}
          renderFallback={() => <Skeleton className="w-full bg-background min-h-14 rounded-none" />}
        >
          <SidebarRobotInfo />
        </HubsConnectionGuard>
      </div>
      <SidebarLink
        path={`/${robotId}/overview`}
        title="Overview"
        icon="overview"
        iconBadge={activeFaultsIndicator ? 'warning' : undefined}
        hasWarningIcon={newNotificationIndicator}
      />
      
      <SidebarLink
        path={`/${robotId}/manual-control`}
        title="Manual Control"
        icon="manual_controller"
        permission={Permission.VIEW}
      />
        
      {!isWearable && global.clientConfig?.reactAppMenuHide3dMaps !== 'true' && (
        <SidebarLink path={`/${robotId}/3d-maps`} title="3D Maps" icon="map_3d" />
      )}
      {!isWearable && (
        <SidebarLink
          path={`/${robotId}/map`}
          title="Mission Execution"
          icon="geo_map"
          permission={Permission.VIEW}
        />
      )}
      {!isWearable && global.clientConfig?.reactAppMenuHideAutowalk !== 'true' && (
        <SidebarLink path={`/${robotId}/missions`} title="Autowalk" icon="route" />
      )}
      {!isWearable && global.clientConfig?.reactAppMenuHideScheduleMissions !== 'true' && (
        <SidebarLink
          path={`/${robotId}/scheduled-missions`}
          title="Scheduled Missions"
          icon="pending_actions"
        />
      )}
      <SidebarLink path={`/${robotId}/settings`} title="Settings" icon="gear" />
      {isSettingsPage && <SidebarLink path={`/${robotId}/settings/webhooks`} title="Webhooks" icon={<WebhookIcon />} sub />}

      <DebugOnlyWrapper>
        <DebugMenu />
      </DebugOnlyWrapper>
    </>
  );
};

export default SidebarRobot;
